// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/switch/Uncontrolled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Switch } from '@sail/ui';
export const Uncontrolled = () => {
  return <Switch onChange={e => {
    // eslint-disable-next-line no-console
    console.log(e.target.checked);
  }} defaultChecked label="This Switch is uncontrolled." />;
};